<div class="content dark">
	<div class="row">
		<div class="col-lg-12">
				HI comparison for previous 50 samples
			<app-dvs-chart [options]="boxPlotOptions" [error]="plotError"></app-dvs-chart>
		</div>
	</div>
</div>